// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeAboutContactPersonAddTemplate_heading__OoqvG","buttonLink":"LandscapeAboutContactPersonAddTemplate_buttonLink__lXQYO"};